const BrassicasDiseaseList = ({ listOfIssues, toDisplay }) => {
    const values = listOfIssues.filter(value => toDisplay.includes(value));
    return (
        <>
            <ul className="list-group list-group-horizontal list-group-flush">
                <li className="list-group-item">
                    Useful for:
                </li>
                {values.includes('darkLeafSpot'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://potatoes.ahdb.org.uk/knowledge-library/brassica-crop-walkers-guide" target="_blank" rel="noreferrer"> Dark leaf spot - Alternaria</a>
                    </li>
                    : <></>
                }
                {values.includes('downyMildew'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://potatoes.ahdb.org.uk/knowledge-library/brassica-crop-walkers-guide" target="_blank" rel="noreferrer">Downy Mildew</a>
                    </li>
                    : <></>
                }
                {values.includes('lightLeafSpot'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://potatoes.ahdb.org.uk/knowledge-library/brassica-crop-walkers-guide" target="_blank" rel="noreferrer">Light leaf spot</a>
                    </li>
                    : <></>
                }
                {values.includes('ringspot'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://potatoes.ahdb.org.uk/knowledge-library/brassica-crop-walkers-guide" target="_blank" rel="noreferrer">Ringspot</a>
                    </li>
                    : <></>
                }
                {values.includes('xanthomonas'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://horticulture.ahdb.org.uk/knowledge-library/xanthomonas-black-rot-of-vegetable-brassicas" target="_blank" rel="noreferrer">Xanthomonas</a>
                    </li>
                    : <></>
                }
            </ul>
        </>);
};

export default BrassicasDiseaseList;